import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sign-up" }
const _hoisted_2 = { class: "sign-up-form" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "h1" }
const _hoisted_5 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_6 = {
  key: 0,
  class: "btn-wrap"
}
const _hoisted_7 = { class: "caps" }
const _hoisted_8 = { class: "caps" }
const _hoisted_9 = {
  key: 1,
  class: "field form-group"
}
const _hoisted_10 = {
  key: 2,
  class: "field form-group"
}
const _hoisted_11 = { class: "company" }
const _hoisted_12 = {
  key: 3,
  class: "field form-group mt-5"
}
const _hoisted_13 = { class: "phone-group" }
const _hoisted_14 = { class: "phone-code" }
const _hoisted_15 = {
  style: {"flex":"1","position":"relative"},
  class: "ml-2"
}
const _hoisted_16 = {
  key: 4,
  class: "field form-group mt-5"
}
const _hoisted_17 = {
  key: 5,
  class: "mb-4"
}
const _hoisted_18 = { class: "field form-group d-flex align-items-center justify-content-between" }

import {
  ref,
  computed,
  onMounted,
  watch,
  Ref,
} from "vue";
import { Countries } from "@models/const/countries";
import { PhoneCodes } from "@models/const/phoneCodes";
import pinCode from "@/directive/pinCode";
import { AdapterAuthService } from "./adapter";
import RegistrationRequest from "@/api/main/dataSource/api/aba/public/services/models/registration/RegistrationRequest";
import UserType from "@/api/main/models/Enums/UserType";
import { useRoute, useRouter } from "vue-router";
import ErrorModel from "./adapter/models/errorModel";
import { useI18n } from "vue-i18n";

export default /*#__PURE__*/_defineComponent({
  __name: 'sign-up-page',
  props: {
  isCompact: { type: Boolean, value: true },
  msg: { type: String, default: "" },
},
  setup(__props) {

// Импорты из Vue 3 Composition API
const route = useRoute();
onMounted(() => {
  localStorage.setItem("locale", route.query?.lng.toString() || "cz");
});
// Определение пропсов компонента
const props = __props;
const currentCode = ref();
const registrationData = ref(
  new RegistrationRequest({
    AgentCode: "",
    PhoneNumber: "",
    Email: "",
    PinCode: "",
    CompanyName: "",
    TypeUser: UserType.Natural,
  })
);
const countries = Countries;

const phoneCode = ref("");
const country = ref("");
const step = ref(0);
const isPassword = ref(true);
const phone = ref("");
const selectBusines = ref(false);
const check = ref(false);
const router = useRouter();
const adapter = AdapterAuthService.getInstance();
watch(
  () => country.value,
  (value) => {
    const x = Countries.find((el) => el.value == value);
    phoneCode.value = x.code;
  }
);
const { locale } = useI18n();
const curLang = ref("cz");
onMounted(async () => {
  localStorage.setItem("locale", route.query?.lng.toString() || "cz");
  curLang.value = localStorage.getItem("locale") || "cz";
  locale.value = curLang.value;
});
/**текст ошибки */
const authErrorMessage = ref("");
const errorModel = ref(new ErrorModel());
/**есть ошибка */
const isAuthNoError = ref(false);
function changeCountry(value) {}
async function onContinue() {
  switch (step.value) {
    case 0:
      checkUniqueEmal();
      break;
    case 1:
      await regStart();
      break;

    case 2:
      await regEnd();
      break;

    default:
      break;
  }
}
function validEmail(value: string): boolean {
  // Регулярное выражение для проверки валидности email
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  // Проверяем, что строка не пуста и соответствует паттерну
  return emailPattern.test(value);
}

function selecttype(value: string) {
  console.log(`value`, value);
  if (value == "business") {
    registrationData.value.TypeUser = UserType.Legal;
    selectBusines.value = true;
  } else {
    registrationData.value.TypeUser = UserType.Natural;
    selectBusines.value = false;
  }
}

async function checkUniqueEmal() {
  errorModel.value = new ErrorModel();
  if (check.value && validEmail(registrationData.value.Email)) {
    const result = await adapter.checkUniqueEmal({
      Email: registrationData.value.Email,
    });

    if (!result.IsSuccess) {
      errorModel.value.ErrorMessage = result.ErrorMessage;
      return;
    }
    step.value += 1;
  }
}

async function regStart() {
  errorModel.value = new ErrorModel();
  if (country.value && phone.value) {
    registrationData.value.PhoneNumber = phoneCode.value + phone.value;

    const result = await adapter.registerStart({
      Email: registrationData.value.Email,
      PhoneNumber: registrationData.value.PhoneNumber,
      TypeUser: registrationData.value.TypeUser,
    });
    if (!result.IsSuccess) {
      errorModel.value.ErrorMessage = result.ErrorMessage;
      return;
    }
    // Проверяем тип возвращаемого значения
    step.value += 1;
  }
}

async function regEnd() {
  errorModel.value.ErrorMessage = "";
  errorModel.value = new ErrorModel();
  if (registrationData.value.PinCode) {
    const result = await adapter.registerEnd({
      Email: registrationData.value.Email,
      PhoneNumber: registrationData.value.PhoneNumber,
      TypeUser: registrationData.value.TypeUser,
      PinCode: registrationData.value.PinCode,
      CompanyName: registrationData.value.CompanyName,
      AgentCode: registrationData.value.AgentCode,
    });

    if (!result.IsSuccess) {
      errorModel.value.ErrorMessage = result.ErrorMessage;
      return;
    }
    // Проверяем тип возвращаемого значения
    router.push({ name: "Login" });
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_second_button = _resolveComponent("second-button")!
  const _component_ui_input = _resolveComponent("ui-input")!
  const _component_ui_select_autocomplete = _resolveComponent("ui-select-autocomplete")!
  const _component_ui_checkbox = _resolveComponent("ui-checkbox")!
  const _component_continue_button = _resolveComponent("continue-button")!
  const _component_ui_message_error = _resolveComponent("ui-message-error")!
  const _component_layout_without_sidebar = _resolveComponent("layout-without-sidebar")!

  return (_openBlock(), _createBlock(_component_layout_without_sidebar, {
    isShowSideBar: false,
    isLogin: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("signup.CREATE ACCOUNT")), 1),
            (step.value == 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                  _createTextVNode(_toDisplayString(_ctx.$t("signup.Already have an account")) + "? ", 1),
                  _createVNode(_component_router_link, { to: "/login" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("Log In")), 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          (step.value == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_second_button, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (selecttype('business'))),
                  isUnselect: !selectBusines.value
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("signup.Business")), 1)
                  ]),
                  _: 1
                }, 8, ["isUnselect"]),
                _createVNode(_component_second_button, {
                  class: "ml-4",
                  isUnselect: selectBusines.value,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (selecttype('personal')))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("signup.Personal")), 1)
                  ]),
                  _: 1
                }, 8, ["isUnselect"])
              ]))
            : _createCommentVNode("", true),
          (step.value == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_ui_input, {
                  modelValue: registrationData.value.Email,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((registrationData.value.Email) = $event)),
                  headerText: _ctx.$t('Your email address'),
                  warningMsg: _ctx.$t('FillThisField'),
                  required: ""
                }, null, 8, ["modelValue", "headerText", "warningMsg"])
              ]))
            : _createCommentVNode("", true),
          (selectBusines.value && step.value == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_ui_input, {
                    type: "Text",
                    modelValue: registrationData.value.CompanyName,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((registrationData.value.CompanyName) = $event)),
                    headerText: _ctx.$t('signup.Company name'),
                    warningMsg: _ctx.$t('Fill This Field'),
                    required: ""
                  }, null, 8, ["modelValue", "headerText", "warningMsg"])
                ])
              ]))
            : _createCommentVNode("", true),
          (step.value == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_ui_select_autocomplete, {
                    keyField: "value",
                    valueField: "text",
                    selectText: "value",
                    items: _unref(countries),
                    class: "indentification-input mr-4",
                    style: {"flex":"0.5"},
                    headerText: _ctx.$t('signup.CountryOfIssuance') + '*',
                    noUndefined: true,
                    modelValue: country.value,
                    "onUpdate:modelValue": [
                      _cache[4] || (_cache[4] = ($event: any) => ((country).value = $event)),
                      changeCountry
                    ]
                  }, null, 8, ["items", "headerText", "modelValue"]),
                  _createElementVNode("div", _hoisted_14, _toDisplayString(phoneCode.value ? `(${phoneCode.value})` : ""), 1),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_ui_input, {
                      modelValue: phone.value,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((phone).value = $event)),
                      type: "number",
                      headerText: _ctx.$t('signup.Phone'),
                      warningMsg: _ctx.$t('Fill This Field'),
                      required: ""
                    }, null, 8, ["modelValue", "headerText", "warningMsg"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (step.value == 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createVNode(_component_ui_input, {
                  type: "number",
                  modelValue: registrationData.value.PinCode,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((registrationData.value.PinCode) = $event)),
                  headerText: _ctx.$t('signup.SMS code'),
                  warningMsg: _ctx.$t('Fill This Field'),
                  required: ""
                }, null, 8, ["modelValue", "headerText", "warningMsg"])
              ]))
            : _createCommentVNode("", true),
          (step.value == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createVNode(_component_ui_checkbox, {
                  modelValue: check.value,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((check).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("signup.SignUpCheckBox")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_continue_button, {
              style: {"width":"100%"},
              onClick: onContinue
            })
          ]),
          _createVNode(_component_ui_message_error, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(errorModel.value.ErrorMessage), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})